export const BOOK_CATAGORIES = "books/catagories";
export const autofillCatagories = (query:string) => `books/autofill-catagories?query=${query}`;
export const BOOKS = "books";
export const CREATE_BOOK = "books/create";
export const DELETE_BOOK = "books/delete"